import { Button, MenuButton, Stack, Typography } from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { regionPageRoute } from "../RegionPage/RegionPage";

export const RegionListPageHeader = (props: { rootPermission: Permission; handle: string }) => {
    const navigate = useNavigate();

    return (
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="inherit">{props.handle}</Typography>
            <Stack direction="row" alignItems="center" spacing="sm">
                {isAuthorized(props.rootPermission, PermissionAction.Create) && (
                    <Button onClick={() => navigate(regionPageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }))} variant="outlined">
                        + New
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};